import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding-top: 3px;\n  line-height: 16px;\n  font-weight: 600;\n  font-size: 12px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 20px;\n  z-index: 2;\n  @media screen and (min-width: ", "px) {\n    display: none;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 600;\n  position: absolute;\n  text-align: center;\n  transform: translateY(50px);\n  width: 75px;\n  height: 50px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  display: flex;\n  height: 64px;\n  justify-content: center;\n  position: relative;\n  width: 64px;\n  transition: background-color 150ms;\n  color: inherit;\n  border: inherit;\n  outline: inherit;\n  &:hover {\n    background-color: rgba(25, 25, 25, 0.6);\n  }\n  margin: 0 7.5px;\n  &:first-child {\n    margin-left: 0px;\n  }\n  &:last-child {\n    margin-right: 0px;\n  }\n\n  path {\n    &[fill] {\n      fill: ", ";\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../utils/styling/styled-components';
import { Ink } from '../Ink';
import { Tooltip, TooltipArrow } from '../Tooltip';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
var Container = styled.button(_templateObject(), function (props) {
  return props.theme.colors.slate;
}, function (props) {
  return props.theme.colors.white;
});
var Label = styled.div(_templateObject2(), function (props) {
  return props.theme.colors.slate;
});
export var ActionButtonTooltip = styled(Tooltip)(_templateObject3(), function (props) {
  return props.theme.breakpoints.md;
});
var LabelInnerText = styled.p(_templateObject4());

var RoundActionButton = function RoundActionButton(props) {
  return /*#__PURE__*/React.createElement(Container, {
    className: props.className,
    onClick: props.onPress,
    onBlur: props.onBlur
  }, /*#__PURE__*/React.createElement(ScreenReaderOnly, null, props.actionText), props.tooltip && /*#__PURE__*/React.createElement(ActionButtonTooltip, {
    position: props.tooltip.position,
    mobileWidthOverride: props.tooltip.mobileWidthOverride,
    visible: true
  }, props.tooltip.text, /*#__PURE__*/React.createElement(TooltipArrow, null)), /*#__PURE__*/React.createElement(Ink, {
    opacity: 0.02
  }), props.icon, props.text && /*#__PURE__*/React.createElement(Label, null, /*#__PURE__*/React.createElement(LabelInnerText, null, props.text)));
};

export { RoundActionButton };